<template>
  <div class="preview-bar">
    <p class="preview-bar__text">Это страница предварительного просмотра!</p>
    <button class="preview-bar__button">Обновить данные</button>
  </div>
</template>

<style lang="postcss" scoped>
.preview-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 60px;
  padding: 6px 12px;
  background-color: var(--accent-second-color);

  &__text {
    font-size: 18px;
    line-height: 20px;
    font-weight: bold;
  }

  &__button {
    padding: 8px 12px;
    border-radius: 4px;
    color: var(--white-color);
    font-size: 16px;
    line-height: 18px;
    background-color: var(--accent-color);
    cursor: pointer;
    transition: background-color var(--default-transition);

    &:hover {
      background-color: rgba(var(--accent-color--rgb), 0.7);
    }
  }

  @media (--small-vp) {
    &__text {
      font-size: 12px;
      line-height: 16px;
    }

    &__button {
      font-size: 12px;
      line-height: 16px;
    }
  }
}
</style>
